<script>
    import user from './stores/user';
    import app_alert from "./stores/alerts";
    import success from './stores/success';
    import {router} from './router/Router.svelte';
    import CheckboxControl from './controls/CheckboxControl.svelte';
    import MessagesPendingRow from "./MessagesPendingRow.svelte";
    import {getMessagesPending, cancelSms, setSmsBlobkStatus, getClientCredits} from "./requests";

    let pendingMessages = [];
    let search = {
        all_messages: false,
    }

    const close = () => {
        router._go("/app");
    }

    const getUserCredits = async () => {
        const [err, res] = await getClientCredits();
        if (err) {
            return;
        }
        if (res) {
            user.updateCredits(res);
        }
    }

    const loadData = async () => {
        const [err, res] = await getMessagesPending(search);

        if (err) {
            return;
        }

        pendingMessages = res;
    }

    const doCancel = async (id) => {
        const [err, res] = await cancelSms(id);

        if (err) {
            return;
        }

        getUserCredits();
        loadData();
    }

    const handleCancel = ({detail}) => {
        app_alert.show('confirm', "Θέλετε να ακυρώσετε αυτό το μήνυμα;", function () {
            doCancel(detail.id);
        });
    }

    const toggleBlock = async (id, block_status) => {
        const [err, res] = await setSmsBlobkStatus(id, block_status);

        if (err) {
            return;
        }

        if (block_status == 0) {
            success.show("Η διακοπή αποστολής του μηνύματος έληξε.");
        } else {
            success.show("Η αποστολή του μηνύματος είναι σε διακοπή.");
        }

        loadData();
    }

    const handleBlock = ({detail}) => {
        toggleBlock(detail.id, 1);
    }

    const handleUnblock = ({detail}) => {
        toggleBlock(detail.id, 0);
    }

    loadData();
</script>

<div class="page-header">
    <div class="page-title">Εξερχόμενα Μηνύματα</div>
    <div class="controls">
        <div title="Ανανέωση λίστας" on:click|preventDefault="{ loadData }">
            <span class="icon"><i class="fa fa-refresh"></i></span>
            <span class="caption">Ανανέωση</span>
        </div>
        <div title="Κλείσιμο" on:click|preventDefault="{ close }">
            <span class="icon"><i class="fa fa-times"></i></span>
        </div>
    </div>
</div>

<div class="page">
    <div class="page-main">

        {#if $user.is_admin}
            <div class="panel">
                <div class="panel-body">
                    <div class="form-group">
                        <label>ΕΜΦΑΝΙΣΗ</label>
                        <CheckboxControl label="Όλων των πελατών" bind:checked="{ search.all_messages }" on:click="{ loadData }"/>
                    </div>
                </div>
            </div>
        {/if}

        <div class="panel">
            <div class="panel-heading hidden-xs">
                MHNYMATA
            </div>
            {#if pendingMessages.length}
                <div class="table-responsive">
                    <table class="table table-bordered table-hover table-list table-data mrg-b-none">
                        <thead>
                        <tr>
                            {#if $user.is_admin}
                                <th>Id</th>
                            {/if}
                            <th>Ημερομηνία</th>
                            {#if $user.is_admin}
                                <th>Λογαριασμός</th>
                            {/if}
                            <th>Αποστολέας</th>
                            <th>Μήνυμα</th>
                            <th>Προγραμματισμός</th>
                            <th class="text-right">Παραλήπτες</th>
                            {#if $user.is_admin}
                                <th>Από</th>
                            {/if}
                            <th></th>
                            <th style="width:90px;"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {#each pendingMessages as message}
                            <MessagesPendingRow message="{ message }" on:cancel="{ handleCancel }"
                                                on:block="{ handleBlock }" on:unblock="{ handleUnblock }"/>
                        {/each}
                        </tbody>
                    </table>
                </div>
            {:else}
                <div class="panel-body">
                    <p>Δεν υπάρχουν εξερχόμενα μηνύματα</p>
                </div>
            {/if}
        </div>
    </div> <!-- /page-content -->
</div>
